
























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {NotificationBanner} from '@/types';
import {Mutation} from 'vuex-class';

@Component({})
export default class NotificationBannerToast extends Vue {
  @Mutation private dismissNotificationBanner: any;
  @Prop({ default: false}) private testing!: boolean;
  @Prop({ default: false}) private showBanner!: boolean;
  @Prop() private banner!: NotificationBanner;


  private mounted() {
    this.bannerShown = this.showBanner;
  }

  private set bannerShown(value: boolean) {
    this.$emit('update:showBanner', value);
  }

  private get bannerShown() {
    return this.showBanner;
  }
}
